import { PageTitle } from 'presentation/components/PageTitle';

import { useNavigate, useSearchParams } from 'react-router-dom';

import IconSim from 'assets/icons/device-ssd-fill.svg';
import IconMap from 'assets/icons/pin-map-fill.svg';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { AREA_CODE, AREA_ID } from '../CU-055-02';

const CU05503Page = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const areaCodeParam = searchParams.get(AREA_CODE) || '';
    const areaIdParam = searchParams.get(AREA_ID) || '';
    const redirectCU05504 = () => {
        navigate(
            `${PRIVATE_ROUTES.PATH}/${
                PRIVATE_ROUTES.SUB.CU_055_04
            }?${`${AREA_CODE}=${areaCodeParam}`}&${`${AREA_ID}=${areaIdParam}`}`,
        );
    };
    const redirectCU05505 = () => {
        navigate(
            `${PRIVATE_ROUTES.PATH}/${
                PRIVATE_ROUTES.SUB.CU_055_05
            }?${`${AREA_CODE}=${areaCodeParam}`}&${`${AREA_ID}=${areaIdParam}`}`,
        );
    };
    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexFlow: 'column',
            }}
            className="CU-055-03-container"
        >
            <PageTitle title="絞り込み方法を選択" />

            <section
                style={{
                    height: '100%',
                    overflow: 'auto',
                    flexGrow: 1,
                }}
            >
                <section style={{ width: 710 }}>
                    <div className="title-card-area" style={{ marginBottom: 24 }}>
                        絞り込み方法を選択してください
                    </div>
                    <div className="area-container">
                        <div className="card-area" onClick={() => redirectCU05504()}>
                            <div className="item-area glow-on-hover">
                                <div className="element">
                                    <div>
                                        <img src={IconMap} />
                                    </div>
                                    <div className="item-text-area">市区町村から探す</div>
                                </div>
                            </div>
                        </div>
                        <div className="card-area" onClick={() => redirectCU05505()}>
                            <div className="item-area glow-on-hover">
                                <div className="element">
                                    <div>
                                        <img src={IconSim} />
                                    </div>
                                    <div className="item-text-area">駅から探す</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </section>
        </div>
    );
};

export default CU05503Page;
